<div class="container">
    <br>
    <h3 style="text-align: center;">Menu</h3>
    <div style="display: flex; justify-content: space-between;">
      <button class="btn btn-primary" (click)="toInsertForm()">Add</button>
      <form class="form-inline">
        <input class="form-control mr-sm-2" type="text" placeholder="Search" #search>
        <button class="btn btn-success" (click)="startSearch($event, search.value)">Search</button>
      </form>
    </div>
    <br>
    <br>

    <table class="table">
        <thead>
            <tr>
                <th *ngFor="let header of headers">{{header}}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let dish of menu">
                <td>{{dish.name}}</td>
                <td></td>
                <td>{{dish.description}}</td>
                <td>{{dish.price}}</td>
                <td>
                    <button class="btn btn-warning m-1"
                    #editId><a routerLink='/edit-form/{{dish.id}}'>Edit</a>
                    </button> 
                    <button class="btn btn-danger m-1" 
                    (click)="ondelete($event, deleteId.value)" 
                    value={{dish.id}} #deleteId>
                    Delete</button>
                </td>
                <td>
                  <button type="button" class="btn btn-primary" (click)="onToggle($event, myModal)">
                    Upload
                  </button>

                  <!-- The Modal -->
                  <div class="modal" id="myModal" #myModal>
                    <div class="modal-dialog">
                      <div class="modal-content">

                        <!-- Modal Header -->
                        <div class="modal-header">
                          <h4 class="modal-title">Modal Heading</h4>
                          <button type="button" class="close" (click)="onDismiss($event, myModal)">&times;</button>
                        </div>

                        <!-- Modal body -->
                        <div class="modal-body">
                          <h5>Upload new photo</h5>
                          <form action="/profile" method="post" enctype="multipart/form-data">
                            <input type="file" class="form-control-file" name="uploaded_file">
                            <input type="submit" value="Upload" class="btn btn-primary" (click)="onUpload()"> 
                          </form>
                        </div>

                        <!-- Modal footer -->
                        <div class="modal-footer">
                          <button type="button" class="btn btn-danger" (click)="onDismiss($event, myModal)">Close</button>
                        </div>

                      </div>
                    </div>
                  </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<div class="container">
    <nav>
        <ul class="pagination">
          <li class="page-item">
            <a class="page-link" href="#" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
              <span class="sr-only">Previous</span>
            </a>
          </li>
          
          <li *ngFor="let page of pages" (click)=changepage()>
            <a class="page-link" routerLink="/menu/{{page}}">{{page}}</a>
          </li>

          <li class="page-item">
            <a class="page-link" href="#" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
              <span class="sr-only">Next</span>
            </a>
          </li>
        </ul>
      </nav>
</div>
